import { get, map, uniqBy } from 'lodash';
import { NETWORK_INFO_BY_ID, NETWORK_INFO_MAP } from '../../../../constants/networks';
import { ACTIVATION_TYPE_CUSTOM } from '../../../../constants/activation-task';

export default {
    computed: {
        requiredNetworks() {
            if (!get(this, 'brief.tasks', false)) {
                return [];
            }

            const networks = this.brief.tasks
                .filter((task) => task.type && task.type !== ACTIVATION_TYPE_CUSTOM)
                .filter((task) => task.is_required || task.is_selected)
                .filter((task) => task.requires_oauth)
                .map((task) => NETWORK_INFO_MAP[task.type]);

            return uniqBy(networks, 'id');
        },
        optionalNetworks() {
            if (!this.brief) {
                return [];
            }

            const requiredIds = map(this.requiredNetworks, 'id');

            const networks = this.brief.tasks
                .filter((task) => task.type && task.type !== ACTIVATION_TYPE_CUSTOM)
                .filter((task) => task.is_selected)
                .filter((task) => !requiredIds.includes(task.network_id))
                .map((task) => NETWORK_INFO_MAP[task.type]);

            return uniqBy(networks, 'id');
        },
        contentTrackingNetworks() {
            if (!get(this, 'brief.content_tracking_networks', false)) {
                return [];
            }

            return this.brief.content_tracking_networks.map((networkId) => NETWORK_INFO_BY_ID[networkId]);
        },
        optionalAndTrackedNetworks() {
            return uniqBy(this.optionalNetworks.concat(this.contentTrackingNetworks), 'id');
        }
    }
};
